import React, { Component,useEffect } from 'react';
import { Card, Button, CardTitle, CardText, CardImg } from 'reactstrap';
import '../css/styles.css';
import ME from '../image/a.jpg';

import 'bootstrap/dist/css/bootstrap.min.css';
function About(){
    
    return(
        
        <div data-AOS="fade-right" className="container">
            <h4 className="about">About Me</h4><br/>
            <div className="row ">
                
                <div className="col-12 col-md-6">
                <p>Hello! I'm Karan Patel, a software engineer based in Bangalore, India.</p>
                <p>I enjoy creating things that live on the internet, whether that be websites, applications, or anything in between. My goal is to always build products that provide best user experiences.</p>

                <p>I am pursing B.E in Computer Science Engineering, I am working as freelancer Web Developer and Content Writer. You can contact me for any freelancer project <a>here</a>. In free time, I am working on some Personal project meaningful projects on a daily basis.</p>    
                </div>
                <div className="col-12 col-md-6" >
                    <img src={ME}  className="img-1-photo" width="200" height="200" viewBox="0 0 200 200"  />
         
                </div>
            </div>
        </div>
    )

}

export default About;